import { ThunkAction } from "redux-thunk";
import ActionCallbacks from "types/ActionCallbacks";
import { Props as ProjectListItemProps } from "../components/ProjectListItem";
import State from "../../models/State";
import * as projectApi from "../api/project";
import * as actionTypes from "./actionTypes";

export function setLoading(loading: boolean) {
  return {
    type: actionTypes.PROJECT_LIST_SET_LOADING,
    payload: loading
  };
}

export function setProjects(projects: ProjectListItemProps[]) {
  return {
    type: actionTypes.PROJECT_LIST_SET_PROJECTS,
    payload: projects
  };
}

export function fetchProjects(callbacks?: ActionCallbacks): ThunkAction<Promise<void>, State, any, any> {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const projects = await projectApi.get();
      dispatch(setProjects(projects));
      if (callbacks != null && callbacks.onSuccess != null) callbacks.onSuccess();
    } catch (error) {
      if (callbacks != null && callbacks.onError != null) callbacks.onError(error);
    }
    dispatch(setLoading(false));
  };
}
